<template>
  <tr
    class="table-row"
    :class="{
      'table-row-selected': selected
    }"
    @click="onClickSelected">
    <td v-if="isInternal">{{ item.student.internal_id }}</td>
    <td>{{ item.student.public_id }}</td>
    <td>{{ item.student.first_name }}</td>
    <td>{{ item.student.last_name }}</td>
    <td>{{ requesterName }}</td>
    <td>{{ item.requester_relationship }}</td>
    <td>{{ startDateDisplay }}</td>
    <td>{{ endDateDisplay }}</td>
    <td>{{ directionDisplay }}</td>
  </tr>
</template>


<script>
export default {
  components: {},
  props: {
    item: Object,
    selected: Boolean,
    isInternal: Boolean
  },
  data() {
    return {
      open: false,
      directions: {
        I: 'Inbound',
        O: 'Outbound',
        B: 'Both',
      },
    }
  },
  methods: {
    async toggleDetails() {
      if (!this.open) {
        // do something
      }
      this.open = !this.open
    },
    clickEvent() {
      // add other pure events on the student item here
    },
    onClickSelected() {
      this.$emit('changeSelected', this.item.id)

      // do something
    },
    onClickExpand() {
      if (this.open) {
        setTimeout(this.toggleDetails, 0)
      }
    },
  },
  computed: {
    requesterName() {
      if (!this.item) return ''

      return `${this.item.requester_first_name} ${this.item.requester_last_name}`
    },
    startDateDisplay() {
      if (!this.item.start_date) return ''

      return new Date(this.item.start_date).toLocaleString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        timeZone: 'UTC',
      })
    },
    endDateDisplay() {
      if (!this.item.end_date) return ''

      return new Date(this.item.end_date).toLocaleString('en-US', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        timeZone: 'UTC',
      })
    },
    directionDisplay() {
      if (this.item === undefined) return ''

      return this.directions[this.item.direction]
    },
  },
  watch: {
    selected: async function () {
      if (!this.selected) {
        this.open = false
      }
    },
  },
  async created() {
    if (this.selected) {
      this.toggleDetails()
    }
  },
}
</script>

<style></style>
